const stopClickThrough = ((bodyCls) => {
    // let scrollTop;
    return {
        afterOpen() {
            // const doc = document.scrollingElement || document.body || document.documentElement;
            // scrollTop = doc.scrollTop;
            // document.body.classList.add(bodyCls);
            // document.body.style.top = -scrollTop + 'px';
            document.body.style.overflow = 'hidden';
        },
        beforeClose() {
            // const doc = document.scrollingElement || document.body || document.documentElement;
            // document.body.classList.remove(bodyCls);
            // scrollTop lost after set position:fixed, restore it back.
            // doc.scrollTop = scrollTop;
            // document.body.style.top = '';
            document.body.style.overflow = '';
        }
    };
})('dialog-open');

const isEmpty = (param) =>
    param === '' ||
    param === null ||
    param === undefined ||
    JSON.stringify(param) === '{}' ||
    (Array.isArray(param) && param.length <= 0);

const getTimeStampForCache = () => {
    const date = new Date();
    const minutes = date.getMinutes();
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}_${date.getHours()}-${
        minutes >= 2 ? minutes.toString().slice(0, 1) : '0'
    }0`;
};

export { stopClickThrough, isEmpty, getTimeStampForCache };
